module.exports = __webpack_public_path__ + "static/sjova-2-eb0810e0e7900b21763b3a19436017d8.jpg";